export enum PermissionEnum {
  NONE = 0,
  READ = 1 << 0, // 0001
  CREATE = 1 << 1, // 0010
  UPDATE = 1 << 2, // 0100
  DELETE = 1 << 3, // 1000
}

export const PermissionLevel = {
  NONE: PermissionEnum.NONE,
  READ_ONLY: PermissionEnum.READ,
  EDIT: PermissionEnum.READ | PermissionEnum.CREATE | PermissionEnum.UPDATE | PermissionEnum.DELETE,
};
